import { render, staticRenderFns } from "./zfbaobiao.vue?vue&type=template&id=7012014c&"
import script from "./zfbaobiao.vue?vue&type=script&lang=js&"
export * from "./zfbaobiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports